import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../components/footer/footer.component';
import { HeaderComponent } from '../components/header/header.component';
import { SideMenuComponent } from "../components/side-menu/side-menu.component";
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, SideMenuComponent, HeaderComponent, FooterComponent, RouterOutlet,BreadcrumbComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {


}
